import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function SidebarEmptyState({
  icon,
  title,
  description,
  action,
  className,
  'data-testid': testId,
}: {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
  className?: string
  'data-testid'?: string
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center flex-1 gap-2 text-center px-6 py-12',
        className,
      )}
      data-testid={testId}
    >
      {icon ? <div className="text-muted-foreground/30">{icon}</div> : null}
      <p className="text-sm text-muted-foreground">{title}</p>
      {description ? (
        <p className="text-xs text-muted-foreground/60">{description}</p>
      ) : null}
      {action}
    </div>
  )
}
